var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { useEffect, useState } from "react";
import { create } from "zustand";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { useBackend } from "../../layouts/Wrapper";
import { twMerge } from "tailwind-merge";
import { useMaxHeight } from "../../lib/useMaxHeight";
import { Title, Text } from "../../tremor/Text";
import { Badge } from "../../tremor/Badge";
import { Button } from "../../tremor/Button";
import { XMarkIcon } from "@heroicons/react/24/outline";
export const useWidgetSuggestionsModal = create((set) => ({
    open: false,
    setOpen: (op) => set({ open: op }),
}));
export const WidgetSuggestionsModal = ({}) => {
    const { dashboard, refreshWidgets, tab } = useDashboard();
    const { backend, adminMode } = useBackend();
    const { open, setOpen } = useWidgetSuggestionsModal();
    const { lg, sm } = useMaxHeight();
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [generating, setGenerating] = useState(false);
    const createWidget = (suggestion) => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboard || !backend)
            return;
        let widget = yield backend.widgets.create({
            dashboard: dashboard.id,
            layouts: {
                lg: {
                    x: 0,
                    y: lg,
                    w: 4,
                    h: suggestion.type === "metric" ? 8 : 20,
                },
                sm: {
                    x: 0,
                    y: sm,
                    w: 3,
                    h: suggestion.type === "metric" ? 8 : 20,
                },
            },
            use_in_library: false,
            use_in_chat: false,
            title: suggestion.title || "",
            team: dashboard.team,
            code: "",
            messages: [],
            settings: {},
            error: null,
            tab: tab || 0,
            config: {},
            engine: "python-v1",
            type: suggestion.type || "metric"
        });
        refreshWidgets(backend);
        yield backend.dashboard(dashboard.id).widgetSuggestions.delete(suggestion.id);
        setSuggestions(suggestions.filter((s) => s.id !== suggestion.id));
        yield backend.widget(widget.id).updatePrompts([{
                role: "user",
                content: suggestion.description || "",
            }]);
        refreshWidgets(backend);
    });
    const getWidgetSuggestions = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboard || !backend)
            return;
        setLoading(true);
        const suggestions = yield backend.dashboard(dashboard.id).widgetSuggestions.list();
        setLoading(false);
        setSuggestions(suggestions);
    });
    const generateWidgetSuggestions = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboard || !backend)
            return;
        setGenerating(true);
        yield backend.dashboard(dashboard.id).generateWidgetSuggestions();
        setGenerating(false);
        getWidgetSuggestions();
    });
    useEffect(() => {
        getWidgetSuggestions();
    }, [dashboard]);
    if (!adminMode)
        return React.createElement(React.Fragment, null);
    return (React.createElement(React.Fragment, null,
        React.createElement("dialog", { open: open },
            React.createElement("div", { className: twMerge("onvo-@container/widgetmodal onvo-transition-all onvo-h-[50%] onvo-rounded-2xl onvo-shadow-xl onvo-px-3 onvo-py-4 onvo-animate-dialogOpen onvo-w-[calc(100%-80px)] onvo-max-w-[600px] onvo-z-50 onvo-fixed onvo-bottom-24 onvo-left-[50%] -onvo-translate-x-[50%] onvo-foreground-color onvo-flex onvo-flex-col onvo-border onvo-border-black/10 dark:onvo-border-white/10") },
                React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-justify-end" },
                    React.createElement("div", { className: "onvo-flex onvo-flex-col onvo-flex-grow" },
                        React.createElement(Title, { className: "onvo-mt-1" }, "Widget Suggestions"),
                        React.createElement(Text, null, "Choose a widget to add to your dashboard")),
                    React.createElement("div", { className: "onvo-rounded-full onvo-transition-all onvo-size-10 onvo-bg-black/5 dark:onvo-bg-white/5 onvo-flex onvo-items-center onvo-justify-center onvo-cursor-pointer hover:onvo-bg-black/10 dark:hover:onvo-bg-white/10" },
                        React.createElement(XMarkIcon, { className: "onvo-w-6 onvo-h-6 onvo-text-blank dark:onvo-text-white", onClick: () => setOpen(false) }))),
                React.createElement("div", { className: "onvo-overflow-y-auto onvo-flex-grow onvo-mt-4 onvo-px-2 onvo-divide-y onvo-divide-black/10 dark:onvo-divide-white/10 onvo-flex onvo-flex-col onvo-bg-black/5 dark:onvo-bg-white/5 onvo-rounded-2xl onvo-border onvo-border-black/10 dark:onvo-border-white/10" },
                    suggestions.map((suggestion) => (React.createElement("div", { className: "onvo-py-4 onvo-px-4 onvo-flex onvo-flex-row onvo-gap-2 onvo-justify-between onvo-items-center", key: suggestion.id },
                        React.createElement("div", { className: "onvo-flex-grow" },
                            React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-gap-2 onvo-items-center" },
                                React.createElement(Title, { className: "!onvo-text-sm" }, suggestion.title),
                                React.createElement(Badge, { className: "!onvo-py-0.5" }, suggestion.type)),
                            React.createElement(Text, { className: "onvo-mt-1" }, suggestion.description)),
                        React.createElement(Button, { variant: "secondary", onClick: () => createWidget(suggestion) }, "Add")))),
                    !loading && (React.createElement("div", { className: "onvo-py-2 onvo-flex onvo-justify-center onvo-items-center" },
                        React.createElement(Button, { variant: "secondary", className: "onvo-my-2", isLoading: generating, onClick: generateWidgetSuggestions }, "Generate more suggestions"))))))));
};
//# sourceMappingURL=WidgetSuggestionsModal.js.map